import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DatevWizardState} from '../../+store/datev-wizard.state';
import {DatevWizardExportDateState} from './datev-wizard-export-date.state';


export class DatevWizardExportDateSelectors {

  private static readonly _feature = createFeatureSelector<DatevWizardState>('wizard');

  private static readonly _slice = createSelector(
    this._feature,
    (state): DatevWizardExportDateState => state.datevWizardExportDate,
  );

  public static readonly exportDate = createSelector(
    this._slice,
    (state) => state.exportDate,
  );

  public static readonly exportDateIndependent = createSelector(
    this._slice,
    (state) => state.exportDateIndependent,
  );

}
